//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('consignmentShipments', {
//        templateUrl: 'views/components/views/consignmentShipments/consignmentShipments.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'consignmentShipmentsService', 'logisticService', 'rememberService', function (stateService, utilityService, consignmentShipmentsService, logisticService, rememberService) {

//    		// #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let isLoading = true;

//            let variableNames = {
//                businessco_no_from: '',
//                stockplace_id_from: ''
//            };

//            vm.model = {
//                bgConsignmentShipmentStatus: {
//                    selected: 'ACTIVE',
//                    buttons: [
//                        { id: 'ACTIVE', label: 'gb_consignmentshipment_status_active', color: 'primary', onClick: () => vm.model.bgConsignmentShipmentStatus.selected = 'ACTIVE' },
//                        { id: 'SENT', label: 'gb_consignmentshipment_status_sent', color: 'primary', onClick: () => vm.model.bgConsignmentShipmentStatus.selected = 'SENT' }
//                    ]
//                },
//                filterValueButtons: [
//                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.setting.filterval = '' }
//                ],
//                setting: {},
//                selectListCompanies: [],
//                selectListStockPlaces: [],
//                itemsListShipments: []
//            };
            
//    		// #endregion VARIABLES & DEFINITIONS

//    		// #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await consignmentShipmentsService.getSetting())[0];
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from) !== true) return;
                
//                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no_from });

//                isLoading = false;
//            }
            
//            async function loadShipments() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_from, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.dateselector) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.date_fom) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.date_tom) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.gb_consignmentshipment_status) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.filterval, true) !== true) return;
                
//                vm.model.itemsListShipments = await consignmentShipmentsService.listShipments(vm.model.setting);

//                isLoading = false;
//            }
            
//    		// #endregion LOAD PROCEDURE FUNCTION CALLS
            
//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    switch (key) {
//                        case 'businessco_no_from':
//                            variableNames[key] = stateService.getCurrentName() + '.' + key;
//                            break;
//                        case 'stockplace_id_from':
//                            variableNames[key] = stateService.getCurrentName() + '.' + key + '.' + 'businessco_no_from' + '=' + vm.model.setting.businessco_no_from;
//                            break;
//                        default:
//                            variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                            break;
//                    }
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no_from':
//                        if (utilityService.validateParmsValue(vm.model.setting[id]) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    case 'stockplace_id_from':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//    		// #region FETCH VALUE PROCEDURE FUNCTION CALLS
            
//            function updateStockPlace() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_from) !== true) return;
                
//                consignmentShipmentsService.changeBusiness({ businessco_no_from: vm.model.setting.businessco_no_from }).then((response) => {
//                    vm.model.setting.stockplace_id_from = response[0].stockplace_id_from;

//                    vm.onStockplaceChanged(vm.model.setting.stockplace_id_from);
//                });
//            }
            
//    		// #endregion FETCH VALUE PROCEDURE FUNCTION CALLS
            
//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgConsignmentShipmentStatus = function (value) {
//                vm.model.bgConsignmentShipmentStatus.selected = value;
//                vm.model.setting.gb_consignmentshipment_status = vm.model.bgConsignmentShipmentStatus.selected;

//                loadShipments();
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'consignmentshipment':
//                        go({
//                            consignmentshipment_keyno: '0',
//                            stockplace_id: vm.model.setting.stockplace_id_from
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region FIELD CHANGE FUNCTIONS

//            vm.onBusinessCompanyChanged = function (value) {
//                vm.model.setting.businessco_no_from = value;

//                if (isLoading === true) return;

//                return Promise.all([
//                    loadStockPlaces()
//                ]).then(() => {
//                    rememberFunc('businessco_no_from');
//                    updateStockPlace();
//                    Promise.resolve();
//                });
//            }
            
//            vm.onStockplaceChanged = function (value) {
//                vm.model.setting.stockplace_id_from = value;

//                if (isLoading === true) return;

//                return Promise.all([
//                    rememberFunc('stockplace_id_from')
//                ]).then(() => {
//                    loadShipments();
//                    Promise.resolve();
//                });
//            }
            
//            vm.onDateselectorCheckboxChanged = function (value) {
//                vm.model.setting.dateselector = value;

//                if (isLoading === true) return;

//                loadShipments();
//            }

//            vm.onDateRangeChanged = function (startDate, endDate, dateInterval) {
//                vm.model.setting.date_fom = startDate;
//                vm.model.setting.date_tom = endDate;
//                vm.model.setting.dateselector_index = dateInterval;

//                if (isLoading === true) return;

//                loadShipments();
//            }

//            // #endregion FIELD CHANGE FUNCTIONS

//            // #region ANGULAR LIFECYCLE

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();

//                return Promise.all([
//                    loadStockPlaces()
//                ]).then(() => {
//                    loadShipments();
//                    Promise.resolve();
//                });
//            }

//            // #endregion ANGULAR LIFECYCLE

//        }]
//    });
//})();
